(function() {
  const THEME_KEY = 'ezshop_theme_mode';

  function applyTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    try {
      localStorage.setItem(THEME_KEY, theme);
    } catch (e) {}
  }

  function initDarkMode() {
    // Read saved preference or system preference
    let currentTheme = 'light';
    try {
      const saved = localStorage.getItem(THEME_KEY);
      if (saved === 'dark' || saved === 'light') {
        currentTheme = saved;
      } else if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        currentTheme = 'dark';
      }
    } catch (e) {}

    applyTheme(currentTheme);

    // Attach click listener
    document.addEventListener('click', function(e) {
      const toggleBtn = e.target.closest('#tshirt-theme-toggle');
      if (!toggleBtn) return;

      e.preventDefault();
      const active = document.documentElement.getAttribute('data-theme') || 'light';
      const newTheme = active === 'dark' ? 'light' : 'dark';
      applyTheme(newTheme);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDarkMode);
  } else {
    initDarkMode();
  }
})();
